<template>
	<a
		class="btn btn-primary"
		:href="`/downloadpolicy/ipid?id=${id}`"
		target="_blank"
	>
		<v-icon
			color="white"
			icon="$page"
		/> <translate>View insurance card</translate> &rsaquo;
	</a>
</template>

<script>
export default {
	name: 'InsuranceCardButton',

	props: {
		id: {
			type: [Number, ],
			required: true
		}
	}
};
</script>
